var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"oa-page"},[(_vm.loading)?_c('div',{staticClass:"loading-spinner"}):_vm._e(),(!_vm.loading)?_c('Loading',{staticClass:"iv-loading"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }